export default __webpack_public_path__ + "static/media/bitmap.073ba162.png";